import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "This is Yak Shaving",
  "description": "",
  "published": "2017-01-27T00:00:00.000Z",
  "redirect_from": ["/blog/yak-shaving/swizec/7398"],
  "categories": "Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "/426ac053bb61c7c8cae8d81cbfa7e2a1/t0XHtgJ.gif",
        "alt": null
      }}></img></p>
    <p>{`I sat down to write about a rendering technique I use to quickly wrap random D3 code in React components. I call them "blackbox components" because they're a black box.`}</p>
    <p>{`It's already a chapter in `}<a parentName="p" {...{
        "href": "https://gumroad.com/l/mTWg"
      }}>{`React+D3v4`}</a>{` and a `}<a parentName="p" {...{
        "href": "https://codepen.io/swizec/pen/woNjVw"
      }}>{`CodePen`}</a>{`. How hard can it be to write a post?`}</p>
    <p>{`Then I thought, `}<em parentName="p">{`”This is dumb. People shouldn't keep rewriting this. It should be an npm module.”`}</em></p>
    <p>{`So I started making a library.`}</p>
    <p>{`Then I remembered that `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-19-its-hard-to-package-a-library/swizec/6927"
      }}>{`compiling`}</a>{` `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/livecoding-21-use-babel-for-libraries-not-webpack/swizec/6982"
      }}>{`libraries`}</a>{` sucks.`}</p>
    <p>{`So I went to copy config files from an `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/react-transitionable-component"
      }}>{`old transition library I did`}</a>{`. But the files were old and out of date. Possibly copied from a 0.2.x version of `}<inlineCode parentName="p">{`create-react-app`}</inlineCode>{`.`}</p>
    <p>{`Terrible.`}</p>
    <p>{`So I looked for a `}<inlineCode parentName="p">{`create-react-lib`}</inlineCode>{` because the `}<inlineCode parentName="p">{`-app`}</inlineCode>{` version creates too much stuff that libraries don't need. Like all the setup for `}<inlineCode parentName="p">{`index.html`}</inlineCode>{` and assets and webpack dev and webpack prod and eslint and jest and a default app page and…`}</p>
    <p>{`Couldn't find one. Used `}<inlineCode parentName="p">{`create-react-app`}</inlineCode>{`, ejected, copied config files, removed the parts I don't need.`}</p>
    <p>{`30 minutes in: no post, no library, but I’ve got the config I need to get started.`}</p>
    <p>{`So I copied the code from CodePen and cleaned it up and added some imports and exports. Made it Real Code™.`}</p>
    <p>{`Then I thought, `}<em parentName="p">{`"You know, this technique can work for things that aren't SVG. There's plenty of stuff people might wanna use."`}</em></p>
    <p>{`So I added a version that uses `}<inlineCode parentName="p">{`<div>`}</inlineCode>{` instead of `}<inlineCode parentName="p">{`<g>`}</inlineCode>{`.`}</p>
    <p>{`Then I compiled. `}<inlineCode parentName="p">{`node_modules/babel-cli/bin/babel.js src --out-dir lib`}</inlineCode>{`. It worked! ?`}</p>
    <p>{`Now, how do I test this? ?`}</p>
    <p>{`So I started writing an example project. Create react app and all of that. `}<inlineCode parentName="p">{`npm link`}</inlineCode>{` to use unpublished library. Neat trick, that.`}</p>
    <p>{`I started with the same axis example from CodePen. `}<inlineCode parentName="p">{`import BlackboxSvgHOC`}</inlineCode>{`, use it to make an `}<inlineCode parentName="p">{`Axis`}</inlineCode>{` component, render in an `}<inlineCode parentName="p">{`<svg>`}</inlineCode>{`.`}</p>
    <p>{`Error. Files not found.`}</p>
    <p>{`Investigate, find a typo in the filename, fix, reload, renders default React app.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/01/default-app.gif",
        "alt": null
      }}></img></p>
    <p>{`Waitaminute! Where's my example axis? How am I gonna add more awesome examples if I can't even load an axis?`}</p>
    <p>{`Sigh. There's a nasty error in the console. Pretty sure I've never seen that one before.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/01/error-screenshot.png",
        "alt": null
      }}></img></p>
    <p>{`How do you even debug that? ?`}</p>
    <p>{`So I went to play Dirt3 for 20 minutes. To regain focus, ya know.`}</p>
    <p>{`Then I wrote this story. And I wish I was kidding, but it took me an hour. Twitter is distracting.`}</p>
    <p>{`3 hours after I started: no article, no library, no working code, no example project.`}</p>
    <p>{`This is `}<a parentName="p" {...{
        "href": "https://en.wiktionary.org/wiki/yak_shaving"
      }}>{`yak shaving`}</a>{`. Don't do this.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      